<template>
    <div class="p-grid p-fluid">
        <card-seplag titulo="Cédula C">
            <DataView :value="anosBase" :layout="layout" paginatorPosition="both" :paginator="false" class="p-col-12 ">
                <template #grid="slotProps">
                    
                    <div style="padding: .5em" class="p-col-12 p-md-3" @click="gerarPDF(slotProps.data)">
                        <a href="#" target="">
                        <Panel :header="'Cédula C Ano/Base '+slotProps.data" style="text-align: center">
                            <img src="../../../public/assets/layout/images/ico-cedulac.png" width="25%" alt="Cédula C"/>
                            <div class="car-detail">Gerar  {{slotProps.data}}</div>
                            <!--<Button icon="pi pi-search"></Button>-->
                        </Panel>
                        </a>
                    </div>
                    
                </template>
            </DataView>
            <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="'Cédula C'" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />
        </card-seplag>
        
    </div>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import CardExibirPDF from '@/template/CardExibirPDF.vue'
import DataView from 'primevue/dataview'
import { baseApiUrl } from '@/config/global'

export default {
    name: 'cedulac',
    components: { CardSeplag, DataView, CardExibirPDF},
    data(){
        return{
            apiUrlRecurso:"cedulasc",
            anosBase:null,
            layout: 'grid',
            exibirPDF: false,
            nomeDocumentoPDF: 'Cedula C',
            pdfElement: null
        }
    },
    methods:{
        async carregarDados(){
            var usuario  =  this.$store.getters.getUser
            var cpf = usuario.contaAcesso.pessoa.numrCpf
            var pensionista = this.$store.getters.getIsPensionista
            var bloqueiaExercicio = true
            var v_anosBase  = await this.$http.get(`${baseApiUrl}/${this.apiUrlRecurso}/anobase/${cpf}/${pensionista}/${bloqueiaExercicio}`)
            if(v_anosBase.status==200) {
                this.anosBase = v_anosBase.data
            }
        },
        gerarPDF(ano){

            let usuario  =  this.$store.getters.getUser
            let cpf = usuario.contaAcesso.pessoa.numrCpf
            let numPensionista =  this.$store.getters.getIsPensionista

            let matricula =  this.$store.getters.getMatricula
            if(numPensionista){
                for(let i=0; i< usuario.contaAcesso.listaVinculo.length; i++ ){
                    if(usuario.contaAcesso.listaVinculo[i].numrPensionista != 0 && usuario.contaAcesso.listaVinculo[i].vinculoServidor != null){
                        matricula = usuario.contaAcesso.listaVinculo[i].vinculoServidor.numrMatricula
                        break;
                    }
                }
            }
            let dadosPDF = {
                matricula: matricula,
                cpf: cpf,
                ano: ano,
                pensionista:  numPensionista,
                bloqueiaExercicio: false
            }


            this.$http.post(`${baseApiUrl}/cedulasc/pdf`,JSON.stringify(dadosPDF)).then(res => {
                this.pdfElement = res.data.dadosRelatorioBase64
                this.nomeDocumentoPDF = res.data.nomeArquivo
                this.exibirPDF = true
            })

        }
    },
    mounted(){
        this.carregarDados()
    }
    
}
</script>
<style scoped>
.p-dropdown {
    width: 12em;
}

.p-dataview {
    .car-details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2em;
        border-bottom: 1px solid #d9dad9;
        

        & > div {
            display: flex;
            align-items: center;

            img {
                margin-right: 14px;
            }
        }
    }

    .car-detail {
        padding: 0 1em 1em 1em;
        border-bottom: 1px solid #d9dad9;
        margin: 1em;
        font-weight: bold;
    }

    .p-panel-content {
        padding: 1em;
    }
}

@media (max-width: 1024px) {
	.p-dataview {
        .car-details {
            img {
                width: 75px;
            }
        }
    }
}

/* Dark Theme such as luna-amber, luna-blue, luna-green and luna-pink */
.dark-theme {
    .p-dataview {
        .car-details {
            border-bottom-color: #191919;
        }

        .car-detail {
            border-bottom: 1px solid #191919;
        }
    }
}
</style>